import React from "react";

// Small celtic knot ornament for section dividers
export default function CelticOrnament({ size = 56, className = "" }) {
  return (
    <svg
      width={size}
      height={size / 2}
      viewBox="0 0 120 60"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <g stroke="#c9a961" strokeWidth="1" fill="none" opacity="0.85">
        <path d="M 60 10 C 40 10 30 30 50 30 C 70 30 80 10 60 10 Z" />
        <path d="M 60 50 C 40 50 30 30 50 30 C 70 30 80 50 60 50 Z" />
        <circle cx="10" cy="30" r="3" />
        <circle cx="110" cy="30" r="3" />
        <line x1="16" y1="30" x2="38" y2="30" />
        <line x1="82" y1="30" x2="104" y2="30" />
      </g>
    </svg>
  );
}
